/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'sites/allas/components/standalone/CoverBox/theme';

export const CoverBoxTheme = theme;
